import { atom, useAtom, useAtomValue } from "jotai";

import { type PortfolioSymbol } from "#/types/markets";

export const stalePortfoliosAtom = atom<PortfolioSymbol[]>([]);

export const shouldFetchAccountStateAtom = atom<boolean>((get) => {
  const stalePortfolios = get(stalePortfoliosAtom);

  return stalePortfolios.length > 0;
});

export const useStalePortfolios = () => {
  const [stalePortfolios, setStalePortfolios] = useAtom(stalePortfoliosAtom);
  const shouldFetchAccountState = useAtomValue(shouldFetchAccountStateAtom);

  return {
    stalePortfolios,
    shouldFetchAccountState,
    setStalePortfolios,
  };
};
